/**
 * Main entry
 * This file will be updated periodically by the maintainers,
 * if you modify it check the version changes before opening an issue.
 *
 * For your custom scripts use the 'custom' folder,
 * import your scripts using './custom/custom.js'.
 */

// Import Bootstrap-italia components.
import { loadPlugin } from 'bootstrap-italia/src/js/load-plugin'
import init from 'bootstrap-italia/src/js/plugins/init'
import * as icons from 'bootstrap-italia/src/js/icons'

/**
 * Import all components, to choose components use
 * import {ComponentA, ComponentB, ...} from 'bootstrap-italia'.
 *
 * Docs: https://italia.github.io/bootstrap-italia/docs/come-iniziare/introduzione/#javascript
 * Examples: https://github.com/astagi/demo-bsitalia-2
 */
import * as bootstrap from 'bootstrap-italia'

loadPlugin(icons)
init()

// Component library initialization.
import './custom/component-library-initialization'

// Import custom JS.
import './custom/custom'

/**
 * Export all bootstrap-italia components as `bootstrap`,
 * use your custom.js to customize object.
 *
 * @type {any}
 */
window.bootstrap = bootstrap

// For jquery: see 'bootstrap_italia.libraries.yml'
// import '../../node_modules/@popperjs/core/dist/cjs/popper';

// import '../../node_modules/owl.carousel/dist/owl.carousel'
// import '../../node_modules/owl.carousel/dist/assets/owl.carousel.css';
// import '../../node_modules/owl.carousel';

// import '../../node_modules/svgxuse/svgxuse'


// import '../../node_modules/bootstrap/dist/js/bootstrap'

// import '../../node_modules/bootstrap-select/js/bootstrap-select'
// import '../../node_modules/bootstrap-select/js/i18n/defaults-it_IT'

// import '../../node_modules/bootstrap-italia/src/js/plugins/fonts-loader'
// import '../../node_modules/bootstrap-italia/src/js/plugins/cookiebar'
// import '../../node_modules/bootstrap-italia/src/js/plugins/dropdown'
// import '../../node_modules/bootstrap-italia/src/js/plugins/track-focus'
// import '../../node_modules/bootstrap-italia/src/js/plugins/forward'
// import '../../node_modules/bootstrap-italia/src/js/plugins/navscroll'
// import '../../node_modules/bootstrap-italia/src/js/plugins/history-back'
// import '../../node_modules/bootstrap-italia/src/js/plugins/notification'
// import '../../node_modules/bootstrap-italia/src/js/plugins/progress-donut'
// import '../../node_modules/bootstrap-italia/src/js/plugins/list'
// import '../../node_modules/bootstrap-italia/src/js/plugins/input-number'
// import '../../node_modules/bootstrap-italia/src/js/plugins/carousel'
// import '../../node_modules/bootstrap-italia/src/js/plugins/transfer'
// import '../../node_modules/bootstrap-italia/src/js/plugins/dimmer'

// import './custom/isIe'
// import './custom/forms'
// // Custom theme script
// import './custom/component-library-initialization'
// import './custom/facets-block'
// import './custom/link-target'

import '../scss/theme.scss';
